module.exports = __webpack_public_path__ + "static/media/sales.be1a09d3.svg";